import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  IconButton,
  Grid,
} from "@mui/material";
import React, { useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import Dropdown from "../../reusableComponents/components/generics/Dropdown";
import TextInput from "../../reusableComponents/components/generics/TextInput";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Field, Form } from "react-final-form";
import InsureePicker from "../../pickers/InsureePicker";

function NewConsultantDialog({
  open,
  onClose,
  onAdd,
  rowData,
  onUpdate,
  title,
}) {
  const dispatch = useDispatch();

  const SignInSuccess = useSelector((state) => state);

  const fosaHealthFacilitySpecialtyItems =
    SignInSuccess?.fosaReducer?.fosaHealthFacilitySpecialtyItems;
  const fosaHealthFacilityPositionItems =
    SignInSuccess?.fosaReducer?.fosaHealthFacilityPositionItems;

  const { t } = useTranslation();

  const canSave = (values) => {
    return values.insureeNo && values.positionId && values.specialityId;
  };

  const onSubmit = async (values) => {
    if (!canSave(values)) {
      return;
    }

    if (rowData) {
      onUpdate(values);
    } else {
      onAdd(values);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{title}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        {/* Uncomment and modify the form as needed */}
        <Form
          onSubmit={onSubmit}
          initialValues={{
            insureeNo: rowData?.insuree?.camuNumber,
            name: rowData?.insuree?.otherName,
            designation: rowData?.designation || "",
            positionId: rowData?.position?.id || "",
            specialityId: rowData?.speciality?.id || "",
          }}
          render={({ handleSubmit, form, submitting, pristine, values }) => (
            <form onSubmit={handleSubmit}>
              <Grid container>
                <Grid item xs={12} className="common-input">
                  <Field
                    name="insureeNo"
                    component={InsureePicker}
                    label={t("camuNo")}
                    required
                    type="text"
                    insureeNo={values}
                    disabled={false}
                  />
                </Grid>

                <Grid
                  item
                  xs={6}
                  className="common-input"
                  style={{ marginTop: "2px" }}
                ></Grid>

                <Grid item xs={12} className="common-input">
                  <Field
                    name="positionId"
                    component={Dropdown}
                    label={"Fonctions"}
                    options={fosaHealthFacilityPositionItems.map((item) => ({
                      ...item,
                      label: item.designation,
                      value: item.id,
                    }))}
                    required
                  />
                </Grid>

                <Grid item xs={12} className="common-input">
                  <Field
                    name="specialityId"
                    component={Dropdown}
                    label={"Spécialités"}
                    options={fosaHealthFacilitySpecialtyItems.map((item) => ({
                      ...item,
                      label: item.designation,
                      value: item.id,
                    }))}
                    required
                  />
                </Grid>
              </Grid>
              <DialogActions>
                <Button onClick={onClose}>{t("cancel")}</Button>

                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  size="large"
                  disabled={submitting || pristine}
                >
                  {rowData ? t("Update") : t("Add")}
                </Button>
              </DialogActions>
            </form>
          )}
        />
      </DialogContent>
    </Dialog>
  );
}

export default NewConsultantDialog;
